import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { DoctorPage } from '../pages/doctor/doctor';
import { NursePage } from '../pages/nurse/nurse';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ApiUserProvider } from '../providers/api-user/api-user';
import { HttpModule, Http } from '@angular/http';
//import { HTTP } from '@ionic-native/http/ngx';
import { HttpClientModule,HttpClient } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { DatePipe } from '@angular/common';
import { ImagePicker } from '@ionic-native/image-picker';

//import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { ReserveModalPage } from '../pages/reserve-modal/reserve-modal';
import { EditModalPage } from '../pages/edit-modal/edit-modal';
import { File } from '@ionic-native/file/ngx';
import { Camera, CameraOptions} from '@ionic-native/camera';
import { Base64 } from '@ionic-native/base64/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';


//import { CameraMock } from '@ionic-native-mocks/camera';
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    DoctorPage,
    NursePage,
    ReserveModalPage,
    EditModalPage
  ],
  imports: [
    HttpClientModule,
    HttpModule,
    BrowserModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    DoctorPage,
    NursePage,
    ReserveModalPage,
    EditModalPage
  ],
  providers: [
    DatePipe,
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiUserProvider,
    ImagePicker,
    FileTransfer,
    //FileUploadOptions,
    FileTransferObject,
  File,
  Camera,
  Base64
  ]
  
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts